import { showLobbyFormat } from 'components/SaloonLobby/showLobbyFormat';

import type { HeadsUpIntroDismissReason } from './HeadsUpIntroModal';

/**
 * FIND A HEADS-UP TABLE lands the player on the Sit & Go tab, where the heads-up tables are. The
 * lobby is usually there already, but not always: a post-login tournament resume opens it
 * on Tournaments, and the introduction can wait for a later lobby moment on any tab. Every
 * other way out leaves the tab alone.
 *
 * Once the buy-in lobby ships (EN-11139, `release.sit-go-buy-in-lobby`) this also turns
 * the player's Heads-up chip on if it was off, leaving Six-seat alone.
 */
export const followHeadsUpIntroDismissal = (reason: HeadsUpIntroDismissReason): void => {
  if (reason === 'find-table') showLobbyFormat('sitgo', { sitgoSeats: 'headsUp' });
};
